import type { RadioVariantProps } from "@daangn/carotene";
import { unstable_radioStyle } from "@daangn/carotene";
import clsx from "clsx";
import * as React from "react";

import { Link } from "~/remix-lib";
import * as css from "./RadioAnchor.css";
import { useRadioAnchorContext } from "./context";

export interface RadioAnchorProps
  extends React.HTMLAttributes<HTMLAnchorElement>,
    RadioVariantProps {
  label: React.ReactNode;
  href: string;
  value: string;
}
const RadioAnchor = React.forwardRef<HTMLAnchorElement, RadioAnchorProps>(
  ({ className, href, size, label, value, ...props }, ref) => {
    const { size: ctxSize, defaultValue } = useRadioAnchorContext();

    const isChecked = defaultValue === value;
    const classNames = unstable_radioStyle({ size: size ?? ctxSize });

    return (
      <Link
        ref={ref}
        href={href}
        className={clsx(
          classNames.root,
          css.focusVisible,
          className,
          css.rootSelector,
        )}
        {...props}
      >
        <div
          className={clsx(classNames.control, css.radioControl)}
          data-checked={isChecked ? "" : undefined}
        >
          <div
            className={classNames.icon}
            data-checked={isChecked ? "" : undefined}
          />
        </div>
        <span className={clsx(classNames.label)}>{label}</span>
      </Link>
    );
  },
);
RadioAnchor.displayName = "RadioAnchor";

export default RadioAnchor;
